import React from 'react';
import styled from 'styled-components';
import TrueImpactText from '../base/TrueImpactText';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactTabsProps<T> {
  selectedValue: T;
  tabs: {
    text: string | JSX.Element;
    value: T;
  }[];
  handleChange: (value: T) => unknown;
  className?: string;
}

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  background-color: ${COLORS.whiteBase};
  .modal-tab {
    cursor: pointer;
    font-weight: bold;
    border-bottom: 2px solid transparent;
    transition: border 0.5s;
    padding: ${SPACERS.large} ${SPACERS.medium} ${SPACERS.small}
      ${SPACERS.medium};
    &:hover {
      border-bottom-color: ${COLORS.ctaPrimaryBackground};
    }
  }
  .modal-tab.active {
    color: ${COLORS.ctaPrimary};
    border-bottom-color: ${COLORS.ctaPrimary};
  }
`;

const TrueImpactTabs = <T,>({
  selectedValue,
  tabs,
  handleChange,
  className,
}: TrueImpactTabsProps<T>) => {
  return (
    <StyledDiv className={className}>
      {tabs.map(t => (
        <TrueImpactText
          key={t.value as string}
          onClick={() => handleChange(t.value)}
          className={
            selectedValue === t.value ? 'modal-tab active' : 'modal-tab'
          }
        >
          {t.text}
        </TrueImpactText>
      ))}
    </StyledDiv>
  );
};

export default TrueImpactTabs;
